"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _chips = _interopRequireDefault(require("./chips"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ChipsNumber = props => {
  var _useSize$width, _useSize, _input$value$toString, _input$value;
  const {
    active,
    input,
    extra,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-chipsNumber");
  const inputRef = (0, _react.useRef)(null);
  const unitRef = (0, _react.useRef)(null);
  const unitWidth = (_useSize$width = (_useSize = (0, _ahooks.useSize)(unitRef)) === null || _useSize === void 0 ? void 0 : _useSize.width) !== null && _useSize$width !== void 0 ? _useSize$width : 0;
  const preActive = (0, _ahooks.usePrevious)(active);
  const [inputVal, setInputVal] = (0, _react.useState)((_input$value$toString = input === null || input === void 0 || (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.toString()) !== null && _input$value$toString !== void 0 ? _input$value$toString : '');
  const onInput = v => {
    const reg = new RegExp(input !== null && input !== void 0 && input.precision ? "^[0-9]+.?[0-9]{0,".concat(input.precision, "}$") : '^[0-9]+$');
    if (v === '' || reg.test(v)) {
      var _input$onChange;
      setInputVal(v);
      input === null || input === void 0 || (_input$onChange = input.onChange) === null || _input$onChange === void 0 || _input$onChange.call(input, v ? Number(v) : undefined);
    }
  };
  (0, _react.useEffect)(() => {
    var _input$value$toString2, _input$value2;
    const v = (_input$value$toString2 = input === null || input === void 0 || (_input$value2 = input.value) === null || _input$value2 === void 0 ? void 0 : _input$value2.toString()) !== null && _input$value$toString2 !== void 0 ? _input$value$toString2 : '';
    if (v ? Number(v) !== Number(inputVal) : inputVal !== '') {
      setInputVal(v);
    }
  }, [input === null || input === void 0 ? void 0 : input.value]);
  (0, _react.useEffect)(() => {
    if (active && !preActive && !(input !== null && input !== void 0 && input.readOnly)) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }
  }, [active]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_chips.default, {
    ...restProps,
    active: active,
    className: (0, _classnames.default)(baseClassName, className),
    style: {
      ...style,
      width: 240,
      height: 72
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "".concat(baseClassName, "--inner"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "number-row",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "number-row--input",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "input-mirror",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "input-mirror--value",
              style: {
                maxWidth: "calc(100% - ".concat(unitWidth, "px)")
              },
              children: inputVal
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: unitRef,
              className: "input-mirror--unit",
              children: !!inputVal && (input === null || input === void 0 ? void 0 : input.unit)
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
            ref: inputRef,
            placeholder: input === null || input === void 0 ? void 0 : input.placeholder,
            readOnly: input === null || input === void 0 ? void 0 : input.readOnly,
            value: inputVal,
            style: {
              paddingRight: unitWidth
            },
            onBlur: () => {
              if (inputVal) {
                setInputVal(Number(inputVal).toString());
              }
            },
            onChange: e => {
              onInput(e.target.value);
            }
          })]
        }), !!extra && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "number-row--extra",
          children: extra
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "children-row",
        children: children
      })]
    })
  });
};
var _default = exports.default = ChipsNumber;